import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Copy: React.FunctionComponent<Props> = (props) => {
  const { size = 22, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.25 16.4997C7.74583 16.4997 7.31439 16.3203 6.95567 15.9616C6.59695 15.6029 6.41728 15.1711 6.41667 14.6663V3.66634C6.41667 3.16217 6.59633 2.73073 6.95567 2.37201C7.315 2.01329 7.74645 1.83362 8.25 1.83301H16.5C17.0042 1.83301 17.4359 2.01267 17.7953 2.37201C18.1546 2.73134 18.334 3.16279 18.3333 3.66634V14.6663C18.3333 15.1705 18.1539 15.6023 17.7953 15.9616C17.4366 16.3209 17.0048 16.5003 16.5 16.4997H8.25ZM8.25 14.1663C8.25 14.4425 8.47386 14.6663 8.75 14.6663H16C16.2761 14.6663 16.5 14.4425 16.5 14.1663V4.16634C16.5 3.8902 16.2761 3.66634 16 3.66634H8.75C8.47386 3.66634 8.25 3.8902 8.25 4.16634V14.1663ZM4.58333 20.1663C4.07917 20.1663 3.64772 19.9869 3.289 19.6283C2.93028 19.2696 2.75061 18.8378 2.75 18.333V6.41634C2.75 5.91008 3.16041 5.49967 3.66667 5.49967C4.17293 5.49967 4.58333 5.91008 4.58333 6.41634V17.333C4.58333 17.8853 5.03105 18.333 5.58333 18.333H13.75C14.2563 18.333 14.6667 18.7434 14.6667 19.2497C14.6667 19.7559 14.2563 20.1663 13.75 20.1663H4.58333Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Copy;
